import ResourcesCollectionProto from "./resources-collection-proto"
import Resources from "../resources"
import TimeReport from "../../model2/time-report/time-report"
import TasksResourcesCollection from "./tasks"

export default class TimeReportsResourcesCollection extends ResourcesCollectionProto {

    constructor(resources:Resources, data: any[] = [], options:any = {}) {
        super(resources, data, TimeReport, options)
    }

    removeByTaskId(taskID:ID) {
        _.map(this.models, (timeReport:TimeReport)=>{
            if (timeReport.taskId === taskID) {
                this.remove(timeReport.id)
            }
        })
    }

    linkTasks(tasksCollection: TasksResourcesCollection | null) {

        if (!tasksCollection) return

        _.map(this.models, (timeReport)=>{
            timeReport.task = tasksCollection.get(timeReport.taskId)
        })
    }
}